<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>

<script>
  import echarts from "echarts";
  import { onMounted, ref } from "vue";
  export default {
    name:'echartLine',
    props: {
      echartsData: {
        type: Object
      },
    },
    setup(props) {
      const charts = ref();
      onMounted(() => {
        const chart = charts.value;
        if (chart) {
          var myChart = echarts.init(chart);
          const option = {
            tooltip: {
              trigger: 'axis',
              // formatter: '{b0}<br /><span class="yuan color1"></span>{a0}：{c0}<br /><span class="yuan color2"></span>{a1}：{c1}<br /><span class="yuan color3"></span>{a2}：{c2}'+(props.echartsData.series.length > 3 ?'<br /><span class="yuan color4"></span>{a3}：{c3}':'')
            },
            legend: {               //设置区分（哪条线属于什么）
              data: props.echartsData.dataName
            },
            xAxis: {
              type: "category",
              data: props.echartsData.latelyDays,
              boundaryGap: false,     //坐标轴两边不留白
            },
            yAxis: {
              type: 'value'
            },
            series: props.echartsData.series,
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
      return {
        charts,
      };
    },
  };
</script>